import { render } from "./hostData.vue?vue&type=template&id=77c607e4&scoped=true"
import script from "./hostData.vue?vue&type=script&lang=js"
export * from "./hostData.vue?vue&type=script&lang=js"

import "./hostData.vue?vue&type=style&index=0&id=77c607e4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c607e4"],['__file',"src/views/index/components/hostData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77c607e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77c607e4', __exports__)) {
    console.log('reload')
    api.reload('77c607e4', __exports__)
  }
  
  module.hot.accept("./hostData.vue?vue&type=template&id=77c607e4&scoped=true", () => {
    console.log('re-render')
    api.rerender('77c607e4', render)
  })

}


export default __exports__